import Rete, { Socket} from "rete";
import VueOperationsControl from "./OperationsControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class OperationsControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VueOperationsControl;
    this.props = { emitter, ikey: key };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const OperationSocket = new Socket("Operation");
OperationSocket.combineWith(AnyTypeSocket);
export { OperationSocket };

